import { Component, Input, OnInit, OnChanges } from '@angular/core';
import moment from 'moment';
import 'moment/locale/de';
import { EventService } from '../../../../core/services/event.service';
declare var google: any;
moment.locale('de');

@Component({
    selector: 'event-description',
    templateUrl: './event-description.component.html',
    styleUrls: ['./event-description.component.scss'],
    standalone: false
})
export class EventDescriptionComponent implements OnInit, OnChanges {
  @Input() event;
  @Input() readData;
  @Input() participant = 0;

  opacityColor;
  _date;
  date;
  location;
  organization;
  manager;
  weblinks = [];
  targetGroups = [];
  levels;

  constructor(public eventService: EventService) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes) {
    if (this.event) {
      let _dates = '';
      // if (this.event.eventStart) {
      //   _dates = moment(this.event.eventStart, 'DD.MM.YYYY').format(
      //     'ddd DD.MMMM'
      //   );
      // }
      if (this.event.dates) {
        let divider = ', ';
        if (this.event.datesType === 'oneDay') {
          divider = '';
        }
        if (this.event.datesType === 'longEvent') {
          divider = ' - ';
        }
        if (this.event.datesType === 'fewDays') {
          divider = '/ ';
        }
        if (this.event.datesType === 'repeatEvent') {
          divider = ', ';
        }
        let _data = this.event.dates.split(',');
        _data.forEach(el => {
          if (_dates) {
            _dates =
              _dates +
              divider +
              moment(el, 'DD.MM.YYYY HH:mm').format('dddd, DD. MMMM YY');
          } else {
            _dates = moment(el, 'DD.MM.YYYY HH:mm').format('dddd, DD. MMMM YY');
          }
        });
      }

      this.date = _dates;
      if (this.event.location) {
        this.geoCodeLatLng(
          this.event.location.split(',')[0],
          this.event.location.split(',')[1]
        );
      } else {
        this.location = '';
      }
      if (this.event.weblinks) {
        this.weblinks = this.event.weblinks.split(',');
      } else {
        this.weblinks = [];
      }
      this.opacityColor = this.hexToRGB(this.event.eventType.color, 0.8);
      if (this.event.dates) {
        const dateArr = this.event.dates.split(',');
        if (dateArr.length) {
          this._date = moment(dateArr[0], 'DD.MM.YYYY HH:mm').format('DD. MMM YY');
        } else {
          this._date = '';
        }
        if (this._date === 'Invalid date') {
          this._date = this.event.dates;
        }
      } else {
        this._date = '';
      }
    }
    if (this.readData) {
      this.readData.forEach((el) => {
        if (el.label === 'event.target_group') {
          this.targetGroups = el.data;
        }
        if (el.label === 'event.event_level') {
          this.levels = el.data;
        }
      });
    }
  }

  public geoCodeLatLng(lat, lng) {
    const that = this;
    const geoCoder = new google.maps.Geocoder();
    const latlng = { lat: +lat, lng: +lng };
    geoCoder.geocode({ location: latlng }, function(results, status) {
      if (status === 'OK') {
        that.location = results[0].formatted_address;
      } else {
        that.location = '';
      }
    });
  }

  hexToRGB(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    } else {
      return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    }
  }

  getEventImage(name) {
    return this.eventService.getFileStream(name);
  }
}
